var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5L23.5 23.5",
    stroke: "#949494",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 23.5L23.5 5",
    stroke: "#949494",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.4e490a0ae3d9b2b8fb94f98059f17d34.svg";
export { ForwardRef as ReactComponent };